import * as Yup from "yup";

export const invoiceValidationSchema = Yup.object({
    organizationName: Yup.string().required("Organization name is required"),
    invoiceItems: Yup.array()
      .of(
        Yup.object({
          item: Yup.string().required("Item is required"),
          quantity: Yup.string()
            .required("Quantity is required")
            .matches(/^\d+$/, "Quantity must be a positive integer")
            .test("is-positive", "Quantity must be at least 1", (value) => Number(value) >= 1),
          taxRate: Yup.string().required("Tax rate is required"),
          price: Yup.string()
            .required("Price is required")
            .matches(/^\d+(\.\d{1,2})?$/, "Price must be a valid number with up to 2 decimal places")
            .test("is-non-negative", "Price must be non-negative", (value) => Number(value) >= 0),
          discount: Yup.string()
            .optional()
            .matches(/^\d+(\.\d{1,2})?$/, "Discount must be a valid number with up to 2 decimal places")
            .test("is-non-negative", "Discount must be non-negative", (value) => !value || Number(value) >= 0),
        })
      )
      .min(1, "At least one invoice item is required"),
  });